let titleLevelHelperSingleton;

const titleLevelHelperFactory = function() {
  function TitleLevelHelper() {
    this.TITLE_LEVEL = 0;
    titleLevelHelperSingleton = this;
  }

  TitleLevelHelper.prototype.setLevel = function(level) {
    this.TITLE_LEVEL = Number(level);
  };

  TitleLevelHelper.prototype.computeTitleLevel = function(defaultLevel) {
    return this.TITLE_LEVEL + Number(defaultLevel);
  };

  return titleLevelHelperSingleton ? titleLevelHelperSingleton : new TitleLevelHelper();
};

titleLevelHelperFactory();

export { titleLevelHelperSingleton as titleLevelHelper };
